require('./hireWelcomeAccountComponentStep3.scss');

// @vendor
import React from 'react';
import PropTypes from 'prop-types';

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');

// @constants
const {
    E_ACCOUNT
} = require('constants/operationTypes');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

const HireWelcomeAccountComponentStep3 = (props) => {
    const welcomeAccountComponentStep3TitleClassName = contactCenterClassName('print-title', 'hire-welcome-account-component-step3__title');
    const welcomeAccountComponentStep3SubTitleClassName = contactCenterClassName('print-paragraph', 'hire-welcome-account-component-step3__subtitle');
    const operativeNameKey = `hireWelcomeAccount-hireWelcomeAccount_${props.operativeName}`;
    const titleKey = props.confirmationTitle;
    const subtitleKey = props.confirmationSubtitle;
    const detailContent = props.intervenersEl;
    const operativeNameText = formatText(operativeNameKey);
    return (
        <section>
            <FormattedText
                className={welcomeAccountComponentStep3TitleClassName}
                value={titleKey}
            />
            <ConfirmationScript
                operative={operativeNameText}
                confirmationType={CONFIRMATION_SCRIPT_GREETING}
            />
            <FormattedText
                className={welcomeAccountComponentStep3SubTitleClassName}
                value={subtitleKey}
            />
            {detailContent}
            <div className="hire-welcome-account-component-step3__divider" />
            <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
            <SignaturePattern
                operationType={E_ACCOUNT}
                operationParams={props.params}
            />
        </section>
    )
}

HireWelcomeAccountComponentStep3.propTypes = {
    immHireWelcomeAccount: PropTypes.object.isRequired,
    intervenersEl: PropTypes.any,
    operativeName: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
    confirmationSubtitle: PropTypes.string.isRequired,
    confirmationTitle: PropTypes.string.isRequired
}

export default HireWelcomeAccountComponentStep3;
